import { render, staticRenderFns } from "./BotResponse.vue?vue&type=template&id=71c2d7a9&scoped=true"
import script from "./BotResponse.vue?vue&type=script&lang=js"
export * from "./BotResponse.vue?vue&type=script&lang=js"
import style0 from "./BotResponse.vue?vue&type=style&index=0&id=71c2d7a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2d7a9",
  null
  
)

export default component.exports